<template>
  <a href="specials" class="specials-link" :style="{'color': stylesObj.color}">

    <div class="overlay" :style="gradientStr"></div>
    <div class="content">
      <div>
        <p class="title">See our specials!</p>
        <span class="description">Affordable price for selected vehicles</span>
      </div>
      <span class="label">Buy now!</span>
    </div>
  </a>
</template>

<script>
  export default {
    props: {

      stylesObj: {
        required: true,
        type: Object
      }
    },
    computed: {
      gradientStr () {
        let gradientStr
        let rgbBgColor = this.hexToRgb(this.stylesObj.background)
        if (rgbBgColor) {
          gradientStr =
            `background: linear-gradient(90deg, rgba(${rgbBgColor.r},${rgbBgColor.g},${rgbBgColor.b},1) 0%,` +
            `rgba(${rgbBgColor.r},${rgbBgColor.g},${rgbBgColor.b},1) 45%, ` +
            `rgba(${rgbBgColor.r},${rgbBgColor.g},${rgbBgColor.b},0)65%);`
        }
        return gradientStr
      }
    },
    methods: {
      hexToRgb (hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null
      }
    }
  }
</script>

<style>
  .specials-link {
    color: #fff;
    background-image: url('../../assets/specials-btn.png');
    background-repeat: no-repeat;
    background-position: 0 30%;
    background-size: cover;
    position: relative;
    display: block;
  }

    .specials-link > .content {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      margin: 15px 0;
      position: relative;
      z-index: 1;
    }

    .specials-link > .overlay {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: rgb(43, 123, 207);
      background: linear-gradient(90deg, rgba(43, 123, 207, 1) 0%, rgba(43, 123, 207, 1) 45%, rgba(0, 212, 255, 0) 65%);
    }

    .specials-link > div {
      flex: 1;
    }

    .specials-link .title {
      padding: 0;
      margin: 0 0 10px 0;
      font-size: 1.4em;
      font-weight: 600;
    }

    .specials-link .description {
      display: inline-block;
      max-width: 130px;
    }

    .specials-link .label {
      display: inline-block;
      padding: 5px 20px;
      background-color: red;
      margin-top: auto;
      color: #fff;
    }

    .specials-link .title,
    .specials-link .label {
      text-transform: uppercase;
      font-weight: 600;
    }
</style>



// WEBPACK FOOTER //
// specials-link.vue?414cd290